import React from "react";

const DealerProfile = () => <div className="content"><h2>Dealer Profile</h2></div>;

export default DealerProfile; 